import PmgImage from "./image/Pmg_big.png";
import { observer } from 'mobx-react';
import { useStore } from "../../state/MobxContext";
import Box from '@mui/material/Box';
import { makeStyles, useMediaQuery } from "@material-ui/core";




function PmgBar() {


    const { MissionStore } = useStore();


    const useStyles = makeStyles((theme) => ({
        //PmgImageLocation
        PmgImageLocation: {
            width:"100%",
            height:"auto",
            margin:0,
            padding:0,
        },
        PmgImageLocationMobile: {
            width:"100%",
            height:"auto",
            margin:0,
            padding:0,
        },
    }));
    
    
    const classes = useStyles();
    const isMobile = useMediaQuery("(max-width: 600px)");






    return(
        <div>
            <Box sx={ isMobile? {maxWidth: 'full', mx: 'auto'} 
            : { maxWidth: 'full', mx: 'auto'}} >
                    <img id="image_id" src={PmgImage} className={ isMobile? classes.PmgImageLocationMobile : classes.PmgImageLocation } alt="PmgImage" onClick={(e) => { MissionStore.setCheakMobile("image_id") }} /> 
            </Box> 
        </div>
    )
};

export default observer(PmgBar);